module.exports = __webpack_public_path__ + "img/22.27e0f172.svg";